import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import StaffListTable from 'components/organismos/master/general/staff/StaffListTable';
import BlockUI from 'components/molecules/BlockUi';
import { useStaffList } from './hooks';

const StaffsPage: React.FC = () => {
  const {
    staffList,
    fetchData,
    executiveId,
    setExecutiveId,
    employmentId,
    setEmploymentId,
    orgCode,
    setOrgCode,
    stateStatus,
    setStateStatus,
    blocking,
    detailRole,
    underFlag,
    setUnderFlag,
    defaultStateStatus
  } = useStaffList();

  return (
    <SidebarTemplate
      pageTitle="スタッフ一覧"
    >
      <BlockUI blocking={blocking}>
        <StaffListTable
          staffList={staffList}
          fetchData={fetchData}
          executiveId={executiveId || ""}
          setExecutiveId={setExecutiveId}
          employmentId={employmentId || ""}
          setEmploymentId={setEmploymentId}
          orgCode={orgCode || ""}
          setOrgCode={setOrgCode}
          stateStatus={stateStatus || defaultStateStatus}
          setStateStatus={setStateStatus}
          detailRole={detailRole}
          underFlag={underFlag || 0}
          setUnderFlag={setUnderFlag}
        />
      </BlockUI>
    </SidebarTemplate>
  );
};

export default StaffsPage;
